<template>
    <v-container fluid pa-0>
        <v-layout row wrap v-if="$basket.getTotalDiscount()">
            <v-flex xs8>
                {{ 'discount' | translation }}
            </v-flex>
            <v-flex xs4 text-xs-right>
              - {{$basket.getTotalDiscount() | currency}}
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs8>
                <p class="mb-0">{{ 'Total' | translation }}</p>
                <p class="caption mb-0">{{ 'price_excl_vat' | translation }}</p>
            </v-flex>
            <v-flex xs4 text-xs-right>
                {{$grillshop.getBasketTotalExclVat() | currency}}
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs8>
                <p class="mb-0">{{ 'Total' | translation }}</p>
                <p class="caption mb-0">{{ 'incl. VAT' | translation }}</p>
            </v-flex>
            <v-flex xs4 text-xs-right>
                {{$basket.getBasketTotal() | currency}}
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'BasketTotals'
};
</script>
